var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TitleOnboarding',{attrs:{"step":"manage-rewards","title":"Set Up Reward Program","page":true}}),_c('ManageRewards',{attrs:{"page":true},on:{"save":_vm.onSave}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }